"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.localLog = exports.handleRouteConfig = exports.getLiveTime = void 0;
var startTime = Date.now();
function getLiveTime() {
    if (window.performance.now) {
        return Math.floor(window.performance.now());
    }
    else {
        var nowTime = Date.now() - 0;
        return Math.floor(startTime - nowTime);
    }
}
exports.getLiveTime = getLiveTime;
function handleRouteConfig(_a) {
    var matched = _a.matched, rest = __rest(_a, ["matched"]);
    return rest;
}
exports.handleRouteConfig = handleRouteConfig;
var local = JSON.parse(localStorage.getItem('monitor') || '[]');
var localLog = function (data) {
    ;
    data.t = Date.now();
    local.push(data);
    localStorage.setItem('monitor', JSON.stringify(local));
};
exports.localLog = localLog;
